import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import Logo from "@/components/Logo";
import { apiErrorMessage } from "@/lib/api";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "", role: "employee" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await register(form);
      toast.success("Conta criada com sucesso");
      navigate("/dashboard", { replace: true });
    } catch (err) {
      setError(apiErrorMessage(err));
    } finally {
      setLoading(false);
    }
  };

  const setField = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  return (
    <div className="min-h-screen flex items-center justify-center bg-[var(--unigr-bg)] p-6">
      <div className="w-full max-w-md bg-white border border-[var(--unigr-border)] rounded-xl p-8 shadow-sm">
        <Logo />
        <div className="mt-6">
          <div className="eyebrow mb-2">Criar conta</div>
          <h1 className="font-display text-3xl font-extrabold">Solicitar acesso à UNIGR</h1>
          <p className="text-sm text-slate-600 mt-2">Após o cadastro, sua empresa poderá vincular você à trilha de aprendizagem do seu cargo.</p>
        </div>
        <form className="mt-6 space-y-4" onSubmit={submit} data-testid="register-form">
          <div>
            <Label>Nome completo</Label>
            <Input value={form.name} onChange={(e) => setField("name", e.target.value)} required data-testid="register-name-input" />
          </div>
          <div>
            <Label>E-mail corporativo</Label>
            <Input type="email" value={form.email} onChange={(e) => setField("email", e.target.value)} required data-testid="register-email-input" />
          </div>
          <div>
            <Label>Senha (mínimo 6 caracteres)</Label>
            <Input type="password" minLength={6} value={form.password} onChange={(e) => setField("password", e.target.value)} required data-testid="register-password-input" />
          </div>
          {error && <div className="text-sm text-red-600" data-testid="register-error">{error}</div>}
          <Button type="submit" disabled={loading} className="btn-navy w-full" data-testid="register-submit-btn">
            {loading ? "Criando…" : "Criar conta"}
          </Button>
        </form>
        <div className="mt-6 text-sm text-slate-600">
          Já tem acesso? <Link to="/login" className="text-[var(--unigr-navy)] font-medium hover:underline">Entrar</Link>
        </div>
      </div>
    </div>
  );
}
